/* REACT PACKAGE IMPORTS */
import { useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Loading from '../Components/Loading'

/* INTERNAL IMPORTS */
import {
  userLoaded,
  userLogged,
  getAuthStatus,
  authError,
} from "../Features/Auth/Slices/authSlice";
import { LoginAuthAction } from "../Features/Auth/Actions/AuthActions";
import { openModal } from "../Features/Errors/Slices/errorSlice";
import "../styles/Login.css";
import { graphConfig, loginRequest } from "../authConfig";


import { useMsal } from "@azure/msal-react";

async function callMsGraph(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers
  };

  return fetch(graphConfig.graphMeEndpoint, options)
    .then(response => response.json())
    .catch(error => console.log(error));
}


export default function CandidateLoginEntra({ logo }) {
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const navigate = useNavigate();

  const { status } = useSelector(state => state.auth);
  const isError = useSelector(getAuthStatus) === "failed" ? true : false;
  const message = useSelector(authError);
  const isLoaded = useSelector(userLoaded);
  const user = useSelector(userLogged);

  const mounted = useRef(null);

  /* UseEffect functions */
  useEffect(() => {
    document.title = "VX";
  }, []);

  useEffect(() => {
    if (message) {
      dispatch(
        openModal({
          message: message,
          severity: "warning"
        })
      );
    }
  }, [isError]);

  useEffect(() => {
    mounted.current = true;
    const queryUser = query.get("username");
    const queryPassword = query.get("password");

    if (!queryUser || !queryPassword) return;
    if (mounted.current) {
      const credentials = {
        username: queryUser,
        password: queryPassword,
      };
      dispatch(LoginAuthAction(credentials))
        .unwrap()
        .then(response => {
          //if (!response.error) document.body.requestFullscreen();
        })
        .catch(() => navigate("/candidate/error", { replace: true }));
    }
    return () => mounted.current = false;
  }, [query]);

  useEffect(() => {
    mounted.current = true;

    if (!isLoaded) return;
    if (mounted.current && status === "succeeded") {
      navigate("/candidate", { replace: true });
    }
    return () => mounted.current = false;
  }, [isLoaded, user, navigate]);

  const RequestProfileData = () => {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraph(response.accessToken).then((response) => {
          const credentials = { fifaid: response.id };
          dispatch(LoginAuthAction(credentials))
        });
      });
  };

  useEffect(() => {
    RequestProfileData();
  }, []);


  return (
    <main className="Login position-relative">
      <Loading />
    </main>
  );
}
